import React, { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import AuditLoggingMain from "../AuditLogging/AuditLoggingMain";
import { getLogsById } from "../AuditLogging/AuditLogsAPIs";
import { selectIsEffectiveAdmin, selectIsEffectiveSupportAdmin } from "../../utilities/adminUtils";
import { getTaskManagerAuditRoute, TASK_MANAGER_ROUTE } from "./constants";

const TaskManagerAuditLogging = () => {
  const { dashboardId } = useParams();
  const [logsData, setLogsData] = useState();
  const isPortalAdmin = useSelector(selectIsEffectiveAdmin);
  const isSupportAdmin = useSelector(selectIsEffectiveSupportAdmin);
  const canView = isPortalAdmin || isSupportAdmin;
  const dashboardRoute = `${TASK_MANAGER_ROUTE}/${dashboardId}`;

  useEffect(() => {
    let cancelled = false;
    window.scrollTo(0, 0);
    getLogsById(`TASK_MANAGER#${dashboardId}`)
      .then((logs) => {
        if (!cancelled) setLogsData(logs);
      })
      .catch(() => {
        if (!cancelled) setLogsData([]);
      });
    return () => {
      cancelled = true;
    };
  }, [dashboardId]);

  if (!canView) return <Redirect to={dashboardRoute} />;

  return (
    <AuditLoggingMain
      logsData={logsData}
      headerHref={getTaskManagerAuditRoute(dashboardId)}
      sideNavBack={dashboardRoute}
      sideHeader={`Audit Logs of TASK_MANAGER#${dashboardId}`}
    />
  );
};

export default TaskManagerAuditLogging;
